import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-meal-period",
  "use": "icon-meal-period-usage",
  "viewBox": "0 0 1025 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1025 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-meal-period\"><path d=\"M1024.001456 512c0 317.224683-240.26655 512-512 512C241.769472 1024 0.001456 811.11125 0.001456 512 0.001456 229.181257 229.246604 0 512.001456 0c282.786797 0 512 229.181257 512 512zM512.001456 73.156548C269.626463 73.156548 73.158004 269.593062 73.158004 512c0 242.343046 196.468459 438.811506 438.843452 438.811506S950.812961 754.343046 950.812961 512c0-242.406938-196.436513-438.843452-438.811505-438.843452z\" p-id=\"9296\" /><path d=\"M768.049375 548.546328H512.001456A36.514382 36.514382 0 0 1 475.455127 512V219.405753a36.546328 36.546328 0 1 1 73.156549 0v255.984027h219.437699a36.578274 36.578274 0 0 1 0 73.156548z\" p-id=\"9297\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/meal-period.svg
// module id = 8JkE
// module chunks = 67